import React from "react";
import { Link } from "gatsby";
import * as styles from "./PageLabel.module.css";

const PageLabel = ({ children, to, style, lightOnDark }) => {
  const classes = `smallBodyText textMarginBottom label ${lightOnDark ? styles.lightOnDark : ""}`;
  const moreStyles = {
    display: "inline-block",
    style
  }

  if (to) {
    return <Link to={to} className={classes} style={moreStyles}>{children}</Link>
  } else {
    return <div className={classes} style={style}>{children}</div>
  }
}

export default PageLabel;
